import { Injectable, OnDestroy } from '@angular/core';
import { CometChat } from './cometchat-sdk';
import { ChatStore } from '../state/chat.store';
import { ChatMessage } from '../models/chat-message.model';

const LISTENER_ID = 'RSM_CHAT_LISTENER';

@Injectable({ providedIn: 'root' })
export class CometChatListenerService implements OnDestroy {

  private currentUid: string | null = null;

  constructor(private store: ChatStore) {}

  register(currentUid: string): void {
    this.currentUid = currentUid;
    CometChat.addMessageListener(
      LISTENER_ID,
      new CometChat.MessageListener({
        onTextMessageReceived: (message: any) => {
          this.handleIncoming(message);
        },
      })
    );
  }

  unregister(): void {
    CometChat.removeMessageListener(LISTENER_ID);
  }

  ngOnDestroy(): void {
    this.unregister();
  }

  private handleIncoming(message: any): void {
    const activeChannel = this.store.activeChannel;
    if (!activeChannel) return;

    const receiverType = String(message.getReceiverType?.() || '').toUpperCase();
    const receiverId = String(message.getReceiverId?.() || '');
    const senderUid = String(message.getSender?.()?.getUid?.() || '');

    const guid = activeChannel.cometChatGuid;
    const isForActiveChannel =
      (receiverType === 'GROUP' && receiverId === guid)
      || (receiverType === 'USER' && activeChannel.channelType === 'DIRECT'
          && !!guid && (senderUid === guid || receiverId === guid));

    if (!isForActiveChannel) return;

    const chatMsg: ChatMessage = {
      id:         String(message.getId()),
      text:       message.getText(),
      senderUid:  message.getSender().getUid(),
      senderName: message.getSender().getName() ?? message.getSender().getUid(),
      sentAt:     new Date(message.getSentAt() * 1000),
      isOwn:      message.getSender().getUid() === this.currentUid,
    };
    this.store.appendMessage(chatMsg);
  }
}
